import { Box, Typography, Card, CardMedia, CardContent, Button, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { PARTNERS } from '@/utils/partners.ts';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const PartnersList = () => {
  const navigate = useNavigate();

  const handleSolicitar = (partnerId: string) => {
    navigate(`/partners/apply/${partnerId}`);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 700 }}>
        Colaboradores
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Descubre los colaboradores exclusivos que tenemos para ti.
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {PARTNERS.map((partner) => (
          <Card
            key={partner.id}
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              overflow: 'hidden',
              transition: 'transform 0.2s, box-shadow 0.2s',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 4,
              },
            }}
          >
            <CardMedia
              component="img"
              sx={{
                width: { xs: '100%', md: 300 },
                height: { xs: 200, md: 'auto' },
                objectFit: 'contain',
                bgcolor: 'background.paper',
                p: 2,
              }}
              image={partner.imageUrl}
              alt={partner.title}
            />
            <CardContent sx={{ flex: 1, p: 3, display: 'flex', flexDirection: 'column' }}>
              <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                {partner.title}
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                {partner.description}
              </Typography>

              {partner.websiteUrl && (
                <Link
                  href={partner.websiteUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 2 }}
                >
                  Conoce a SEAG
                  <OpenInNewIcon fontSize="small" />
                </Link>
              )}

              {partner.additionalLinks && partner.additionalLinks.length > 0 && (
                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                    Enlaces de interés:
                  </Typography>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                    {partner.additionalLinks.map((link, index) => (
                      <Link
                        key={index}
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.5,
                          fontSize: '0.875rem',
                        }}
                      >
                        {link.label}
                        <OpenInNewIcon fontSize="small" />
                      </Link>
                    ))}
                  </Box>
                </Box>
              )}

              <Button
                variant="contained"
                color="primary"
                onClick={() => handleSolicitar(partner.id)}
                sx={{ alignSelf: 'flex-start' }}
              >
                Más información/Aplicar
              </Button>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default PartnersList;
